import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { useInterval } from '@dni-react-hooks/use-interval'
import { useState } from 'react'

export function useCountUp(defaultSeconds = 0) {
  const [isCounting, setIsCounting] = useState(false)
  const [seconds, setSeconds] = useState(defaultSeconds)

  useInterval(() => {
    setSeconds(value => value + 1)
  }, isCounting ? 1000 : null)

  const startCountUp = useCallbackEvent(() => {
    setSeconds(defaultSeconds)
    setIsCounting(true)
  })

  const stopCountUp = useCallbackEvent(() => {
    setIsCounting(false)
  })

  return {
    startCountUp,
    stopCountUp,
    seconds,
    isCounting,
  }
}
